export const isImg = url => {
  if (!url) return false

  return (
    url.endsWith('.jpg') ||
    url.endsWith('.png') ||
    url.endsWith('.jpeg') ||
    url.endsWith('.gif') ||
    url.endsWith('.svg') ||
    url.endsWith('.webp') ||
    url.endsWith('.bmp') ||
    url.endsWith('.ico') ||
    url.endsWith('.apng') ||
    url.endsWith('.avif') ||
    url.endsWith('.jfif') ||
    url.endsWith('.pjpeg') ||
    url.endsWith('.pjp') ||
    url.endsWith('.tiff')
  )
}
